<template>
  <footer>
    <div class="footer-divider" />
    <div>
      <div class="footer-social">
        <a
          v-for="(item, key) in social"
          :key="key"
          :href="item.url"
          target="_blank"
        >
          <FaIcon :icon="item.icon" />
        </a>
      </div>
      <div class="footer-links">
        <router-link :to="{ name: 'about' }">About</router-link>
        <router-link :to="{ name: 'support' }">Support</router-link>
        <router-link :to="{ name: 'disclaimer' }">Disclaimer</router-link>
        <router-link :to="{ name: 'cookies' }">Cookies Policy</router-link>
      </div>
      <div class="footer-legal">
        <p>© {{ year }} Little Arms Studios Inc.</p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAppStore } from '@/stores/app';
import FaIcon from '@/components/FaIcon.vue';

const store = useAppStore();
const social = computed(() => store.social);
const year = new Date().getFullYear();
</script>

<style lang="scss" scoped>
footer {
  position: relative;
  text-align: center;
  font-weight: 600;
  padding: 0;
  z-index: 2;
  background-color: #f1f1f1;
  flex-grow: 1;
}

.footer-divider {
  $divider-height: 1px;
  height: $divider-height;
  margin: 0 40px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: $divider-height * 0.5;
}

.footer-social {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;

  a {
    margin: 0 20px;
    font-size: 30px;
  }
}

.footer-links {
  a {
    position: relative;
    font-size: 0.8em;
    padding: 0 10px;

    &:not(:last-child) {
      &::after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        border-left: 2px solid gray;
      }
    }

    &:hover {
      color: #ff6e41;
      text-decoration: underline;
    }
  }
}

.footer-legal {
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  font-size: 15px;

  p {
    font-size: inherit;
    margin: 0;
  }
}
</style>
